import { render, staticRenderFns } from "./AddServices.vue?vue&type=template&id=47fe136f&"
import script from "./AddServices.vue?vue&type=script&lang=ts&"
export * from "./AddServices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports